<payee-popup title="Értesítés törlése">
  <div class="dialog-content flex column vcenter">
    <div class="confirmation-message">
      <p>
        <span>Biztosan törölni szeretné az"</span>
        <strong>{{ data.notification.name }}</strong>
        <span>" értesítést?</span>
      </p>
    </div>

    @if (errorMessage) {
      <div class="error-message">
        {{ errorMessage }}
      </div>
    }
  </div>

  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      type="button"
      color="alert-red"
      [disabled]="loading"
      (click)="onSubmit()"
    >
      Törlés
    </button>
  </ng-template>

  <ng-template #payeePopupCancelTemplate>
    <button
      payee-button
      type="button"
      [disabled]="loading"
      (click)="onCancel()"
    >
      Mégse
    </button>
  </ng-template>
</payee-popup>
